import { DETOX_PROMPTS } from '../../lib/detoxPrompts';

export default function DetoxDayTrail({ currentDay, checkins }) {
  return (
    <div className="detox-trail">
      {DETOX_PROMPTS.map(({ day, theme, emoji }) => {
        const done     = checkins.some(c => c.day_number === day);
        const isToday  = day === currentDay;
        const locked   = day > currentDay;

        return (
          <div
            key={day}
            className={`trail-step ${done ? 'done' : ''} ${isToday ? 'today' : ''} ${locked ? 'locked' : ''}`}
          >
            <div className="trail-bubble">
              {done ? '✅' : locked ? '🔒' : emoji}
            </div>
            <div className="trail-info">
              <span className="trail-day">Dia {day}</span>
              <span className="trail-theme">{theme}</span>
            </div>
            {isToday && <span className="trail-badge-today">Hoje</span>}
            {done && checkins.find(c => c.day_number === day)?.stayed_off && (
              <span className="trail-badge-off">📵 Sem redes</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
